import { render, staticRenderFns } from "./WasteClientSignView.vue?vue&type=template&id=00ca30e0&"
import script from "./WasteClientSignView.vue?vue&type=script&lang=js&"
export * from "./WasteClientSignView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports